import { defineComponent, h, resolveComponent } from 'vue';
import { QBtn, QTooltip, QDialog } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';
import FieldPicker from '../fieldPicker.jsx';
import TypeSchema from './typeschema.jsx';

export default defineComponent({
    name: 'schema-form-dsgn',
    components: {
        QBtn,
        QTooltip,
        QDialog,
        FieldPicker,
        TypeSchema,
    },
    data: () => ({
        tab_state: {},
        properties: [],
        pickervisible: false,
        picker: null,
        pickertarget: 'body',
    }),
    props: {
        name: '',
        schemakey: null,
        root: null,
        schema: null,
        form: null,
        cmodel: null,
        designmodel: null,
        child: 0,
        readonly: false,
        extra: null,
        selectable: null,
        selected: null,
        selectFormElement: null,
    },
    methods: {
        addControl(e, target) {
            this.pickertarget = target;
            this.picker = <FieldPicker schema={this.schema} confirm={this.confirmAddControl} cancel={this.cancelAddControl}></FieldPicker>;
            this.pickervisible = true;
            e.cancelBubble = true;
            e.stopPropagation();
        },
        async confirmAddControl(fields) {
            this.pickervisible = false;

            if (this.form && this.form.length === 1 && (typeof this.form[0] === 'string') && this.form[0] == '*')
                this.form.splice(0, 1);

            for (let key in fields) {
                const v = fields[key];
                if (!v) continue;

                const fieldSchema = utils.schema.resolve_Of(v.type);

                const m = utils.schema.createDefaultModel(fieldSchema, this.root); // schema);
                m.key = key;
                m.$objectid = utils.generateUUID();
                this.form.push(m);
            }
        },
        cancelAddControl() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
        addTab(e, tabs, state) {
            const tabItem = {
                $typeSchema: '/schema/public/Platform.Schema.FormControls.v1/FormControl_Tabs_TabItem',
                title: 'Untitled',
                name: '',
                items: []
            };
            tabs.push(tabItem);
            state.index = tabs.length - 1;

            e.cancelBubble = true;
            e.stopPropagation();

            this.selectFormElement(tabItem);

            this.$forceUpdate();
        },
        selectTab(e, state, tabi, tabItem) {
            state.index = tabi;
            if ('$typeSchema' in tabItem)
                this.selectFormElement(tabItem);
            
            e.cancelBubble = true;
            e.stopPropagation();
        },
        deleteTab(e, state, element, tabi) {
            element.tabs.splice(tabi, 1);
            if (state.index >= element.tabs.length)
                state.index = element.tabs.length - 1;

            const tabItem = element.tabs.length > 0 ? element.tabs[element.tabs.length - 1] : null;
            if ('$typeSchema' in tabItem)
                this.selectFormElement(tabItem);
            else
                this.selectFormElement(null);

            e.cancelBubble = true;
            e.stopPropagation();

            this.$forceUpdate();
        },
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    render() {
        let schema = this.schema;
        if (!schema || !Object.keys(schema).length)
            schema = { type: 'object' };

        let elements = [];
        let child = this.child;

        const SchemaForm = resolveComponent('schema-form-dsgn');
        schema = utils.schema.resolve_Of(schema);

        if (schema.type !== 'object')
            return <div>Schema must be an object</div>;

        const form = {};
        let properties = []; //this.properties;

        // Build a list of properties that represent the fields that will be displayed in this form.
        // Each element will be either the form element, schema element, or the key (field name) in the schema.
        if (this.form)
            for (let i = 0; i < this.form.length; i++) {
                const form_item = this.form[i];
                // Form entities can be a simple string which represents the field name (the key), or '*' meaning 'All fields'.
                if (typeof form_item === 'string') {
                    if (form_item === '*') {
                        if (schema.properties && typeof schema.properties === 'object')
                            for (let key in schema.properties)
                                if (key.substr(0, 1) !== '$' && !properties.includes(key))
                                    properties.push(key);
                    }
                    else
                        properties.push(form_item);
                }
                // Form entities can also be an object, which includes a 'key' field naming the field as well as form-specified properties
                // The 'AllSchemaElements' boolean is functionally the same as the wildcard field '*' addressed above.
                // In this case, loop over all schema properties and add each one to the properties array (as just the string key)
                else if (typeof form_item === 'object' && form_item.AllSchemaElements) {
                    for (let key in schema.properties)
                        if (key.substr(0, 1) !== '$' && !properties.includes(key))
                            properties.push(key);
                }
                // For a form entity that is an object and which has a valid key, push the string key into the properties array
                else if (typeof form_item === 'object' && 'key' in form_item && form_item.key) {
                    properties.push(form_item.key);
                    form[form_item.key] = form_item;
                }
                // For a form entity that does not have a key property, these are non-schema elements like 'help', 'section', etc.
                // These are special form-only elements. Store these in the properties array as the form object.
                else if (typeof form_item === 'object' && (!('key' in form_item) || !form_item.key)) {
                    properties.push(form_item);
                }
            }

        // Next, interate over all properties (some are string keys, others are form objects).
        // Generate a DOM node for each form element.
        for (let i = 0; i < properties.length; i++)
        {
            let childform = null;
            const key = properties[i];
            //if (key.substr(0, 1) == '$') continue;

            const tagItem = utils.forms.getDesignerFormType(this, key, schema, typeof key === 'string' ? form[key] : null, this.cmodel);
            if (tagItem)
                elements.push(tagItem);

            /*
            let element;

            if (typeof key === 'object') {
                // For elements that are objects (which are form-only elements), the entire object is specified
                element = key;
            }
            else {
                // Otherwise, the key is a string that references an element in the schema.
                // The schema must be an object with a properties collection:
                if ('properties' in schema) {
                    if (key in schema.properties)
                        // Direct reference to a schema field
                        element = utils.schema.resolve_Of(schema.properties[key]);
                    else if (key.includes('.')) {
                        // Dot notation for the key: field.subfield.etc -- walk the schema to locate the field
                        const parts = key.split('.');
                        let s = schema;
                        for (let x = 0; s && x < parts.length; x++) {
                            const subkey = parts[x];
                            if ('properties' in s && subkey in s.properties)
                                s = s.properties[subkey];
                        }

                        // If we found the schema field, store it as the 'element' variable
                        if (s)
                            element = utils.schema.resolve_Of(s);
                    }
                }
                else
                    // We aren't dealing with an object schema, use the form object itself as the 'element'
                    element = form[key];

                if (!element)
                    continue;

                // Preserve the form object so we can pass it down to any potential complex components
                childform = form[key];

            //    element = {
            //        ...element,
            //        ...form[key],
            //    };
            }

            let cmodel = this.cmodel;
            let Tag;
            let enableSelect = false;
            child = this.child;

            if (element)
                if ('format' in element)
                    switch (element.format) {
                        case 'TextEditor':
                            Tag = 'form-input-multiline';
                            break;

                        case 'ReferencedDocumentSchema':
                            Tag = 'referenced-document-schema';
                            break;

                        case 'LookupList':
                            Tag = 'string-lookup-list-dsgn';
                            break;
                    }

            if (element && !Tag)
                switch (childform?.type ?? element.type) {
                    case 'layoutWrap':
                    case 'actions':
                        elements.push(
                            <SchemaForm name={this.name} designmodel={this.designmodel} root={this.root} schema={this.schema} form={element.items} cmodel={this.cmodel} child={child} selected={this.selected}>
                            </SchemaForm>
                        );
                        continue;

                    case 'tabs':
                        let state;
                        if (!(element.$objectid in this.tab_state))
                            this.tab_state[element.$objectid] = { index: 0 };

                        state = this.tab_state[element.$objectid];

                        const tabs = [];
                        for (let tabi = 0; tabi < element.tabs.length; tabi++) {
                            if (!('$typeSchema' in element.tabs[tabi]))
                                element.tabs[tabi]['$typeSchema'] = '/schema/public/Platform.Schema.FormControls.v1/FormControl_Tabs_TabItem';

                            const tab_style = {
                                float: "left",
                                borderTop: "1px solid black",
                                borderLeft: "1px solid black",
                                borderRight: "1px solid black",
                                marginRight: "1px",
                                padding: "5px 5px 3px",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                            };
                            if (tabi === state.index) {
                                tab_style.fontWeight = "bold";
                            }
                            else {
                                tab_style.backgroundColor = "gray";
                                tab_style.color = "silver";
                            }

                            let icon;
                            if (this.selected && state.index === tabi)
                                icon = (
                                    <span class="designer-form" style={{ zIndex: 32, color: "maroon", marginLeft: "3px", cursor: "pointer" }}
                                        onClick={(e) => this.deleteTab(e, state, element, tabi)}>
                                        <i class="mdi mdi-close-circle" title="Delete Tab" />
                                    </span>
                                );

                            tabs.push(
                                <div style={tab_style} onClick={(e) => this.selectTab(e, state, tabi, element.tabs[tabi])}>
                                    <span class={{ 'designer-form': this.selected }} style={{ zIndex: 32, cursor: "pointer" }}>{element.tabs[tabi].title}</span>{icon}</div>);
                        }

                        if (this.selected) {
                            // Include an Add button to add a new tab
                            const addtab = (
                                <span class="designer-form" style={{ zIndex: 32, marginLeft: "5px", cursor: "pointer", color: "blue" }}>
                                    <i class="mdi mdi-plus-circle" title="Add Tab" onClick={(e) => this.addTab(e, element.tabs, state)} />
                                </span>
                            );
                            tabs.push(<div style={{ float: "left" }}> {addtab}</div>);
                        }

                        // Now push the contents of just the active tab
                        if (state.index >= 0 && state.index < element.tabs.length)
                            tabs.push(
                                <div style="margin: 5px; margin-top: 35px; padding: 5px;">
                                    <SchemaForm name={this.name} designmodel={this.designmodel} root={this.root} schema={this.schema} form={element.tabs[state.index].items} cmodel={this.cmodel} child={child} selected={this.selected}>
                                    </SchemaForm>
                                </div>
                            );

                        elements.push(
                            <div>
                                {tabs}
                            </div>
                        );
                        continue;

                    case 'button':
                        Tag = 'form-button-dsgn'; break;
                    case 'help':
                        Tag = 'form-help-dsgn'; break;
                    case 'paragraph':
                        Tag = 'form-paragraph-dsgn'; break;
                    case 'textarea':
                    case 'textareaWithHeaderBar': Tag = 'form-input-multiline-dsgn'; break;

                    case 'string':
                    case 'text':
                    case 'password':
                    case 'phonenumber':
                        if (('anyOf' in element))
                            Tag = 'form-anyof-dsgn';
                        else if (('enum' in element) || ('titleMap' in element))
                            Tag = 'form-select-dsgn';
                        else
                            Tag = 'form-input-dsgn';
                        break;
                    case 'select': Tag = 'form-select-dsgn'; break;
                    case 'radios':
                    case 'radiobuttons':
                    case 'radios-inline': Tag = 'form-radios-dsgn'; break;
                    case 'integer':
                    case 'number': Tag = 'form-number-dsgn'; break;
                    case 'checkbox':
                    case 'boolean': Tag = 'form-checkbox-dsgn'; break;
                    case 'array': Tag = 'form-array-dsgn'; break;
                    case 'localesection':
                    case 'section':
                        Tag = 'form-section-dsgn';
                        childform = element;
                        element = schema;
                        break;
                    case 'tabarray':
                        Tag = 'form-tabarray-dsgn';
                        break;
                    case 'controls-with-label': Tag = 'form-controls-with-label-dsgn'; break;
                    case 'fieldset':
                        elements.push(
                            <SchemaForm name={this.name} designmodel={this.designmodel} root={this.root} schema={this.schema} form={element.items} cmodel={this.cmodel} child={child} selected={this.selected}>
                            </SchemaForm>
                        );
                        continue;
                        //Tag = 'form-fieldset-dsgn'; break;
                    case 'object':
                        enableSelect = true;
                        Tag = 'schema-form-dsgn';
                        if (!cmodel[key])
                            cmodel[key] = {};
                        cmodel = cmodel[key];
                        childform = ['*'];
                        child = 1;
                        break;
                    default:
                        if ('$typeSchema' in element) {
                            const typeSchema = element.$typeSchema;
                            const parts = typeSchema.split('/');
                            elements.push(<TypeSchema name={element.title || key} value={parts[parts.length - 1]} child={child}></TypeSchema>);
                            continue;
                        }

                        let type = ('anyOf' in element) ? 'anyOf' :
                            ('allOf' in element) ? 'allOf' :
                                ('oneOf' in element) ? 'oneOf' :
                                    ('unknown:' + element.type);

                        utils.log('skipping type: ' + type);
                        Tag = 'div';
                        break;
                }

            if (Tag) {
                if (Tag != 'div')
                    Tag = utils.getComponentByTag(Tag, 'default-unknown-dsgn');
                else
                    Tag = h('div');

                const tagItem = <Tag
                    name={element.title || key}
                    type={childform?.type ?? element.type}
                    schemakey={key}
                    schema={element}
                    root={this.root}
                    cmodel={cmodel}
                    form={childform}
                    designmodel={(typeof key === 'object' ? key : form[key])}
                    selectable={enableSelect}
                    child={child}
                    readonly={element.readonly || false}
                    selected={this.selected}>
                </Tag>;

                elements.push(tagItem);
            }
            */
        }

        const dialog = (
            <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                <div style={{ maxWidth: '860px', maxHeight: '80vh', overflow: 'auto' }}>{this.picker}</div>
            </QDialog>
        );

        if (this.selectable) {
            let addbtn;
            if (this.selected$)
                addbtn = (
                    <div class="property-grid designer-form">
                        <QBtn flat size="xs" icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 32 }} onClick={(e) => this.addControl(e, 'body')}>
                            <QTooltip>Add field ({this.schemakey})</QTooltip>
                        </QBtn>
                    </div>
                );

            return (
                <div style={{ width: '100%' }}>
                    <div style="display: flex; flex-direction: column; gap: 10px; position: relative;" onClick={(e) => this.handleClick(e)}>
                        <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                        <h5 style={{ margin: 0, padding: 0 }}>{this.name}</h5>
                        {elements}
                        {addbtn}
                    </div>
                    {dialog}
                </div>
            );
        }


        let addtopbtn;
        if (this.selected || this.selected$)
            addtopbtn = (
                <div class="property-grid designer-form">
                    <QBtn flat size="sm" icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 32 }} onClick={(e) => this.addControl(e, 'body')}>
                        <QTooltip>Add field{this.schemakey ? ` (${this.schemakey})` : ''}</QTooltip>
                    </QBtn>
                </div>
            );

        if (this.child > 0)
            return (
                <div style={{ width: '100%' }}>
                    <h5 style={{ margin: 0, padding: 0 }}>{this.name}</h5>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {elements}
                        {addtopbtn}
                    </div>
                    {dialog}
                </div>
            );
        else
            return (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {elements}
                    {addtopbtn}
                    {dialog}
                </div>
            );
     
    }
});